// extracted by mini-css-extract-plugin
export default {"video-section":"c_d d-flex","video-section--header":"c_f","video-section__frame":"c_g ml-3"};